import { render, staticRenderFns } from "./business-type.vue?vue&type=template&id=64cd6d92&scoped=true"
import script from "./business-type.vue?vue&type=script&lang=js"
export * from "./business-type.vue?vue&type=script&lang=js"
import style0 from "./business-type.vue?vue&type=style&index=0&id=64cd6d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd6d92",
  null
  
)

export default component.exports